import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-216d8284"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "expansion-panels__content-box" }
const _hoisted_2 = {
  key: 0,
  class: "expansion-panels__collapsible-line"
}
const _hoisted_3 = { class: "relative" }
const _hoisted_4 = {
  key: 1,
  class: "expansion-panels__collapsible-line"
}

import { computed, onMounted, ref } from 'vue';
import { useAppStore } from '@/store/modules/app';
import { StyleType } from '@/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseExpansionPanels',
  props: {
    isMobileCollapse: { type: Boolean, default: false },
    isFullCollapse: { type: Boolean },
    styleColor: { default: 'base' },
    withPreview: { type: Boolean, default: false },
    fullWidthMobile: { type: Boolean },
    withoutMobileShadow: { type: Boolean },
    styleType: { default: 'base' },
    isOpen: { type: Boolean },
    isError: { type: Boolean }
  },
  emits: ['openBlock', 'closeBlock'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const openBlock = ref(false);
const handleClick = () => {
  openBlock.value = !openBlock.value;
  if (openBlock.value) {
    emit('openBlock');
  } else {
    emit('closeBlock');
  }
};

const collapseHandler = () => {
  if (
    (props.isMobileCollapse && useAppStore().window <= 600 && !openBlock.value) ||
    props.isFullCollapse
  ) {
    handleClick();
  }
};

const cssProps = computed(() => {
  let color;
  let bgColor;

  switch (props.styleColor) {
    case 'blue':
      color = '#0097CB';
      bgColor = '#F8FDFF';
      break;
    case 'green':
      color = '#009D3E';
      bgColor = '#20a2330f';
      break;
    case 'orange':
      color = '#C16800';
      bgColor = '#c168000a';
      break;
  }

  return {
    '--color': color,
    '--background-color': bgColor,
  };
});

onMounted(() => {
  openBlock.value = props.isOpen;
});

return (_ctx: any,_cache: any) => {
  const _component_base_card = _resolveComponent("base-card")!
  const _component_base_icon = _resolveComponent("base-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ 'with-line': _ctx.styleType === 'with-line' }, "expansion-panels"]),
    style: _normalizeStyle(cssProps.value)
  }, [
    (_ctx.styleType === 'base')
      ? (_openBlock(), _createBlock(_component_base_card, {
          key: 0,
          fullWidthMobile: _ctx.fullWidthMobile,
          "without-mobile-shadow": _ctx.withoutMobileShadow
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "expansion-panels__collapsible base",
              onClick: collapseHandler
            }, [
              _renderSlot(_ctx.$slots, "title", {
                data: openBlock.value,
                events: { handleClick: handleClick }
              })
            ]),
            _createElementVNode("div", {
              class: _normalizeClass([{ open: openBlock.value, withPreview: _ctx.withPreview }, "expansion-panels__content"])
            }, [
              _createElementVNode("div", _hoisted_1, [
                _renderSlot(_ctx.$slots, "content", {
                  data: openBlock.value,
                  events: { handleClick: handleClick }
                })
              ])
            ], 2)
          ]),
          _: 3
        }, 8, ["fullWidthMobile", "without-mobile-shadow"]))
      : _createCommentVNode("", true),
    (
        _ctx.styleType === 'simple' ||
        _ctx.styleType === 'simple-green' ||
        _ctx.styleType === 'with-line'
      )
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass([{
        'expansion-panels--simple': _ctx.styleType === 'simple',
        'expansion-panels--simple-green': _ctx.styleType === 'simple-green',
        'expansion-panels--with-line': _ctx.styleType === 'with-line',
        isError: _ctx.isError,
      }, "border-block expansion-panels--simple"])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass([{
          'start-arrow': _ctx.styleType === 'with-line',
        }, "expansion-panels__collapsible simple"]),
            onClick: handleClick
          }, [
            (_ctx.styleType === 'with-line')
              ? (_openBlock(), _createElementBlock("span", _hoisted_2))
              : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "title", {
              data: openBlock.value,
              events: { handleClick: handleClick }
            }),
            _createElementVNode("button", _hoisted_3, [
              _createElementVNode("span", {
                class: _normalizeClass([{ open: openBlock.value, right: _ctx.styleType !== 'with-line' }, "expansion-panels__collapsible-arrow"])
              }, [
                _createVNode(_component_base_icon, {
                  color: 
                _ctx.isError ? '#EA1F1F' : _ctx.styleType === 'simple-green' ? '#009D3E' : '#868298'
              ,
                  name: "expand_more"
                }, null, 8, ["color"])
              ], 2)
            ]),
            (_ctx.styleType === 'with-line')
              ? (_openBlock(), _createElementBlock("span", _hoisted_4))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass([{ open: openBlock.value, withPreview: _ctx.withPreview }, "expansion-panels__content"])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass({
            'mt--20 mb--20': _ctx.styleType !== 'with-line' && _ctx.styleType !== 'simple-green',
          })
            }, [
              _renderSlot(_ctx.$slots, "content", {
                data: openBlock.value,
                events: { handleClick: handleClick }
              })
            ], 2)
          ], 2)
        ], 2))
      : _createCommentVNode("", true)
  ], 6))
}
}

})